// extracted by mini-css-extract-plugin
module.exports = {"card":"styles-module__card___l6Gip","card-whitelabelled":"styles-module__card-whitelabelled___20X1T"};